export default {
	tenantId: "dbs_uat",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "dbs--uat"
	}
}
